import { Pipe, PipeTransform } from '@angular/core';
import {PhoneNumber} from "../interface/phone-number";

@Pipe({
  name: 'additionalContractPhone'
})
export class AdditionalContractPhonePipe implements PipeTransform {

  transform(value: any): any {
    return value.filter((el: PhoneNumber) => !el.main);

  }

}
